const transcript = {
	gender: (key: string) =>
		({
			'': null,
			female: 'Female',
			Female: 'female',
			male: 'Male',
			Male: 'male',
		})[key],
	family_status: (key: string) =>
		({
			'': null,
			divorced: 'Divorced',
			Divorced: 'divorced',
			married: 'Married',
			Married: 'married',
			single: 'Single',
			Single: 'single',
			widowed: 'Widowed',
			Widowed: 'widowed',
		})[key],
	repeated_client: (key: string) =>
		({
			'': null,
			repeated: 'Repeated',
			Repeated: 'repeated',
			new: 'New',
			New: 'new',
		})[key],
	dual_loans: (key: string) =>
		({
			'': null,
			'1': 'Yes',
			Yes: true,
			'0': 'No',
			No: false,
		})[key],
	client_status_gurantor: (key: string) =>
		({
			'': null,
			'1': 'Yes',
			Yes: true,
			'0': 'No',
			No: false,
		})[key],
	family_members_loans: (key: string) =>
		({
			'': null,
			'1': 'Yes',
			Yes: true,
			'0': 'No',
			No: false,
		})[key],
	family_members_delinquent: (key: string) =>
		({
			'': null,
			'1': 'Yes',
			Yes: true,
			'0': 'No',
			No: false,
		})[key],
	current_application_with_same_family_id: (key: string) =>
		({
			'': null,
			'1': 'Yes',
			Yes: 'Yes',
			'0': 'No',
			No: 'No',
		})[key],
	active_loan_with_same_family_id: (key: string) =>
		({
			'': null,
			'1': 'Yes',
			Yes: 'Yes',
			'0': 'No',
			No: 'No',
		})[key],
};

export default transcript;
